import React from "react";
import OfficePro from "./Office 2021/OfficePro";
import OfficeBussiness from "./Office 2021/OfficeBussiness";
import OfficeStudent from "./Office 2021/OfficeStudent";
import OfficeBussinessMac from "./Office 2021/OfficeBussinessMac";
import OfficeStudentMac from "./Office 2021/OfficeStudentMac";
import OfficePro2019 from "./Office2019/OfficePro2019";
import OfficeBusiness2019 from "./Office2019/OfficeBusiness2019";
import OfficeStudent2019 from "./Office2019/OfficeStudent2019";
import OfficeBusinessMac2019 from "./Office2019/OfficeBusinessMac2019";
import OfficeStudentMac2019 from "./Office2019/OfficeStudentMac2019";
import OfficePro2016 from "./Office 2016/OfficePro2016";
import OfficeBussiness2016 from "./Office 2016/OfficeBussiness2016";
import OfficeStudent2016 from "./Office 2016/OfficeStudent2016";
import OfficeBussinessMac2016 from "./Office 2016/OfficeBussinessMac2016";
import OfficeStudentMac2016 from "./Office 2016/OfficeStudentMac2016";
import Window11Pro from "./Window 11/Window11Pro";
import Window11Home from "./Window 11/Window11Home";
import Window10Home from "./Window 10/Window10Home";
import Window10Pro from "./Window 10/Window10Pro";
import Window8Pro from "./Window 8/Window8Pro";
import Window7Ultimate from "./Window 7/Window7Ultimate";
import Window7Pro from "./Window 7/Window7Pro";
import Window7Home from "./Window 7/Window7Home";

const Product = ({ product }) => {
  const getCategory = (product) => {
    // We need to add case Manually for any new product added
    // Case must match the product name
    switch (product?.name?.replace(/\s+/g, "")) {
      // Office 2021
      case "Office2021Professional":
        return <OfficePro id={product._id} />;
      case "Office2021HomeandBusiness":
        return <OfficeBussiness id={product._id} />;
      case "Office2021HomeandStudent":
        return <OfficeStudent id={product._id} />;
      case "Office2021HomeandBusinessForMAC":
        return <OfficeBussinessMac id={product._id} />;
      case "Office2021HomeandStudentForMAC":
        return <OfficeStudentMac id={product._id} />;
      // Office 2019
      case "Office2019Professional":
        return <OfficePro2019 id={product._id} />;
      case "Office2019HomeandBusiness":
        return <OfficeBusiness2019 id={product._id} />;
      case "Office2019HomeandStudent":
        return <OfficeStudent2019 id={product._id} />;
      case "Office2019HomeandBusinessForMAC":
        return <OfficeBusinessMac2019 id={product._id} />;
      case "Office2019HomeandStudentForMAC":
        return <OfficeStudentMac2019 id={product._id} />;
      // Office 2016
      case "Office2016Professional":
        return <OfficePro2016 id={product._id} />;
      case "Office2016HomeandBusiness":
        return <OfficeBussiness2016 id={product._id} />;
      case "Office2016HomeandStudent":
        return <OfficeStudent2016 id={product._id} />;
      case "Office2016HomeandBusinessForMac":
        return <OfficeBussinessMac2016 id={product._id} />;
      case "Office2016HomeandStudentForMac":
        return <OfficeStudentMac2016 id={product._id} />;
      // Windows 11
      case "Windows11Professional":
        return <Window11Pro id={product._id} />;
      case "Windows11Home":
        return <Window11Home id={product._id} />;
      // Windows 10
      case "Windows10Professional":
        return <Window10Pro id={product._id} />;
      case "Windows10Home":
        return <Window10Home id={product._id} />;
      // Windows 8
      case "Windows8.1Professional":
        return <Window8Pro id={product._id} />;
      // Windows 7
      case "Windows7Ultimate":
        return <Window7Ultimate id={product._id} />;
      case "Windows7Professional":
        return <Window7Pro id={product._id} />;
      case "Windows7Home":
        return <Window7Home id={product._id} />;

      default:
        console.log("No page Found");
    }
  };
  const render = getCategory(product);
  return <>{render}</>;
};

export default Product;
